export default class QueryBuilderNodeNameController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {any} KTranslate
	 */
	constructor($scope, $timeout, KTranslate) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.KTranslate = KTranslate;
		this.name = undefined;

		/**
		 * @type {any}
		 */
		this.node = undefined;
	}

	/**
	 * @param {any} changes
	 */
	$onChanges(changes) {
		if (changes.node) {
			this.name = this.node.name;
			const { linker_kid: linkerKid, linker_info: linkerInfo } = this.node;
			if (linkerKid !== '0') {
				(async () => {
					this.name += ` :: ${linkerInfo?.name || await this.KTranslate.request(this.$scope, linkerKid)}`;
					this.$timeout(() => {
						this.$scope.$apply();
					});
				})();
			}
		}
	}
}
